<template>
  <div>
    <v-row>
      <v-col>Show this category if {{ parentNodeName }} is </v-col>
      <v-col>
        <v-select
          :items="parentRecord.meta.choices || ['true', 'false']"
          v-model="conditionalBoolean"
          @change="setConditions"
        ></v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    node: Object,
    parentNodeId: String,
    parentNodeName: String,
    selectedRecord: Object,
    parentRecord: Object,
    index: Number,
    prexistingCondition: String
  },
  created() {
    if (this.prexistingCondition) {
      if (
        this.prexistingCondition.split(" ")[
          this.prexistingCondition.split(" ").length - 1
        ] == "Yes"
      ) {
        this.conditionalBoolean = this.parentRecord.meta.choices[0];
      } else {
        this.conditionalBoolean = this.parentRecord.meta.choices[1];
      }
      this.setConditions(this.conditionalBoolean);
    }
  },
  data() {
    return {
      conditionalBoolean: true
    };
  },
  methods: {
    setConditions(choice) {
      const choiceBoolified = Boolean(
        !this.parentRecord.meta.choices.indexOf(choice)
      );
      let condition = choice;
      let conditionObject = {
        condition,
        index: this.index
      };
      this.$emit("setCondition", conditionObject);
    }
  }
};
</script>

<style></style>
